// extracted by mini-css-extract-plugin
export default {"container":"ImageCarousel_container__92z1B","slide":"ImageCarousel_slide__9hqzN"};